const MANAGEMENT_ROLES = ['admin', 'manager'];

export const ROLE_STAGE = {
  frame_worker: { status: 'frame_status', assignee: 'frame_worker_id', tab: 1 },
  sewer: { status: 'sewing_status', assignee: 'sewer_id', tab: 2 },
  upholsterer: { status: 'upholstery_status', assignee: 'upholsterer_id', tab: 3 },
};

export const isTaskManagement = (role) => MANAGEMENT_ROLES.includes(role);

export const canEditTaskStage = (user, task, statusField) => {
  if (isTaskManagement(user?.role)) return true;
  const stage = ROLE_STAGE[user?.role];
  return Boolean(stage && stage.status === statusField && task?.[stage.assignee] === user?.id);
};
